import { useCallback, useState, CSSProperties } from 'react';
import { getApiUrl } from '../api';
import { categories, Category, Photo } from '../models_generated';
import { useAsyncEffect } from '../utils/hooks';
import { useParams } from 'react-router-dom';
import { BaseView } from './BaseView';
import { API_STORE } from '../ApiStore';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

export function PhotoPage() {
	let [photo, setPhoto] = useState(undefined as Photo | undefined);

	const { id } = useParams()

	useAsyncEffect(async () => {
		try {
			const resp = await fetch(getApiUrl(`/photo/${id}`), {mode: "cors"})
			setPhoto(await resp.json());
		} catch (e) {
			API_STORE.alertError(e);
		}
	}, [])

	const onFieldUpdated = useCallback(async (field: string, value: string) => {
		try {
			const resp = await API_STORE.doFetch("post", `/photo/${id}/field/${field}`, {jsonBody: {value: value}});
			setPhoto(resp);
		} catch (e) {
			API_STORE.alertError(e);
		}
	}, [])

	const onSaveImage = useCallback(async (field: string, formData: FormData) => {
		try {
			const resp = await fetch(getApiUrl(`/photo/${id}/field/${field}`), {
				method: "post",
				mode: "cors",
				body: formData,
				// headers: { "Content-Type": "application/json" },
			});
			setPhoto(await resp.json());
		} catch (e) {
			alert(e);
		}
	}, []);

	if (!photo) {
		return <h1>Loading</h1>;
	}

	return <BaseView>
		<h1>Photo {id}</h1>
		<div style={{float: "left", width: "49%"}}>
			<div style={{"padding": "10px"}}>
				<EditableField label='Naziv' value={photo.name} field="name" onChange={onFieldUpdated} />
				<EditableCategory label='Kategorija' categoryId={photo.category} field="category" onChange={onFieldUpdated} />
				<EditableField label='Opis' value={photo.description} field="description" onChange={onFieldUpdated} textarea markdown />
				<EditableField label='Vlasnik fotografije' value={photo.owner} field="owner" onChange={onFieldUpdated} />
				<EditableField label='Ključne riječi (za pretraživanje)' value={photo.keywords} field="keywords" onChange={onFieldUpdated} textarea rows={4} />
				<EditableField label='Datum (yyyy-mm-dd, yyyy-mm ili yyyy)' value={photo.date} field="date" onChange={onFieldUpdated} />
				<EditableField label='Objavljeno' value={"" + photo.publish} field="publish" onChange={onFieldUpdated} bool />
				<EditableField label='Zadatak' value={"" + photo.todo} field="todo" onChange={onFieldUpdated} />
			</div>
		</div>
		<div style={{float: "left", width: "49%"}}>
			<div style={{"padding": "10px"}}>
				<EditablePhoto label='Fotografija 1' value={photo.image} field="image" onChange={onSaveImage} />
				<EditablePhoto label='Fotografija 2' value={photo.image2} field="image2" onChange={onSaveImage} />
				<EditablePhoto label='Fotografija 3' value={photo.image3} field="image3" onChange={onSaveImage} />
			</div>
		</div>
		<div style={{clear: "both"}}></div>
	</BaseView>;
}

function EditableField(props: {label: string, field: string, value: string, onChange: (field: string, value: string) => void, textarea?: boolean, rows?: number, markdown?: boolean, bool?: boolean}) {
	let [editing, setEditing] = useState(false);
	let [value, setValue] = useState(props.value);

	const onToggleEdit = useCallback(() => {
		setEditing(!editing);
	}, [editing])

	const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => { setValue(e.target.value) }, []);

	const onSave = useCallback(async () => {
		await props.onChange(props.field, value);
		setEditing(false);
	}, [editing, value]);


	if (editing) {
		return <p style={style}>
			<strong>{props.label || props.field}:</strong><br/>
			{!!props.bool
				? <input type="checkbox" checked={value == "true"} onChange={e => setValue(e.target.checked ? "true" : "false")} />
				: props.textarea
					? <textarea value={value} onChange={onChange as any} rows={props.rows || 20} style={{width: "100%"}} />
					: <input type="text" style={{width: "100%"}} value={value} onChange={onChange} />
			}
			<br/>
			<button onClick={onSave}>save</button>
			<button onClick={onToggleEdit}>cancel</button>
		</p>
	}

	return (<p style={style}>
		<strong>{props.label || props.field}:</strong><br/>
		<div style={{border: "1px solid gray"}}>
			{!props.value && <><em>Prazno</em></>}
			{!!props.markdown && <><ReactMarkdown children={props.value} /></>}
			{!props.markdown && <><strong>{props.value}</strong></>}
		</div>
		<button onClick={onToggleEdit}>edit</button>
	</p>);
}

function EditablePhoto(props: {label: string, field: string, value: string, onChange: (field: string, value: FormData) => void}) {
	let [editing, setEditing] = useState(false);

	const onSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		// alert("Submit");

		const data = new FormData(e.target as any);
		var imagedata = (document.querySelector(`input[id="${props.field}"]`) as any).files[0];
		data.append("image", imagedata);

		setEditing(false);
		await props.onChange(props.field, data);
	}, [])

	const onToggleEditing = useCallback(() => {
		setEditing(!editing)
	}, [editing]);

	if (editing) {
		return <p style={style}>
			<form method='post' onSubmit={onSubmit}>
				<strong>{props.label || props.field}:</strong><br/>
				<input id={props.field} type="file"/>
				<br/>
				<button type="submit">Submit</button>
				<button onClick={onToggleEditing}>Cancel</button>
			</form>
		</p>
	}

	return <p style={style}>
		<strong>{props.label || props.field}:</strong><br/>
		{!!props.value && <img src={props.value + "?=" + Math.random()} style={{width: "300px"}} />}
		{!props.value && "Missing image"}
		<br/>
		<button onClick={onToggleEditing}>Edit</button>
	</p>
}

function EditableCategory(props: {label: string, field: string, categoryId: string, onChange: (field: string, categoryId: string) => void}) {
	let [editing, setEditing] = useState(false);
	let [categoryId, setCategoryId] = useState(props.categoryId)

	const onToggleEditing = useCallback(() => {
		setEditing(!editing)
	}, [editing]);

	const onSave = useCallback(async () => {
		await props.onChange(props.field, categoryId);
		onToggleEditing();
	}, [categoryId, editing]);

	if (editing) {
		return <p style={style}>
			<strong>{props.label || props.field}:</strong><br/>
			<select onChange={e => {
					setCategoryId(e.target.value);
				}}>
				{categories?.map(c => <option selected={c.id==props.categoryId} id={c.id} value={c.id}>{c.description}</option>)}
			</select>
			<br/>
			<button onClick={onSave}>Save</button>
			<button onClick={onToggleEditing}>Cancel</button>
		</p>
	}

	return <p style={style}>
		<strong>{props.label || props.field}:</strong><br/>
		{categories.find(c => c.id ==  props.categoryId)?.description || "<empty>"}
		<br/>
		<button onClick={onToggleEditing}>Edit</button>
	</p>
}

const style = {borderBottom: "1px solid gray", padding: "2px"} as CSSProperties;